// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"fc57ee08","453":"2d854ea1","732":"9e88f919"}[chunkId] + ".chunk.js";
};